import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Navbar from "components/Navbars/AuthNavbar.js";
import secureLocalStorage from "react-secure-storage";

const fetchSettingsByIdentifier = async (identifier) => {
  // console.log("Fetching settings for identifier:", identifier);
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/system-structure/settings/${identifier}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // console.log("Response from settings fetch:", response);
    if (!response.ok) {
      throw new Error("Failed to fetch settings");
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching settings:", error);
    return null;
  }
};

function Landing() {
  const [systemSettings, setSystemSettings] = useState(null);

  useEffect(() => {
    const identifier = window.location.hostname;

    // Get from local storage first
    const cached = secureLocalStorage.getItem("systemSettings");
    let parsedSettings = cached ? JSON.parse(cached) : null;

    fetchSettingsByIdentifier(identifier).then((fetchedSettings) => {
      if (fetchedSettings) {
        setSystemSettings(fetchedSettings);
        secureLocalStorage.setItem("systemSettings", JSON.stringify(fetchedSettings));
      } else if (parsedSettings) {
        setSystemSettings(parsedSettings);
      }
    });
  }, []);

  const backgroundColor = systemSettings?.mainBackground ?? " bg-primary";
  return (
    <div className="landing-page-wrapper">
      <Navbar transparent systemSettings={systemSettings}  />
      <main>
        <div className="relative pt-32 pb-32 flex content-center items-center justify-center min-h-screen">
          {/* Background Section */}
          <div
          style={{backgroundColor}}
            className={`absolute top-0 w-full h-full bg-center bg-cover ${backgroundColor}`}
            
          ></div>

          <div className="container relative mx-auto px-4">
            <div className="flex flex-wrap items-center justify-between text-center w-full">
              {/* Left Section: Text */}
              <div className="w-full  px-8 mb-6 md:mb-0">
                <div className="pt-12 sm:pt-0">
                  <h2 className="text-white mb-4 leading-snug font-black text-[]" style={{fontSize:'3.2rem',fontWeight:900}}>
                
                    {systemSettings?.systemNameFull??"Resource Management System"}
                  </h2>
                  <p className="mt-6 text-lg leading-relaxed text-white text-center">
                  {systemSettings?.otherInfo??"    The ideal centralized management system solution to staying organized, on track, and collaborating with team members."}
                
                  </p>
                  <div className="mt-12">
                    <Link
                      to="/auth/login"
                      className="get-started text-primary font-bold px-12 py-5 rounded outline-none focus:outline-none mr-1 mb-1 bg-white active:bg-primary text-l shadow hover:shadow-lg ease-linear transition-all duration-150"
                    >
                      Get Started
                    </Link>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </main>
    </div>
  );
}

export default Landing;